import React from 'react'
import styled from 'styled-components'
import { Icon } from '@iconify/react'

export function AuthPrevButton (props) {
  return (
    <Button type='button' aria-label='Volver' {...props}>
      <Icon icon='ep:arrow-left-bold' />
    </Button>
  )
}

const Button = styled.button`
  outline: 0;
  border: 0;
  background-color: transparent;
  font-size: 2em;
  color: #a4a4a5;
  position: absolute;
  top: 0.25em;
  left: 0.25em;
  z-index: 1;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: opacity 300ms ease;
  margin-top: 10px;

  &:hover {
    opacity: 0.7;
  }
`

export default AuthPrevButton
